import styled from 'styled-components'

export const BannerContainer = styled.div`
  width: 100%;
  margin: 40px 0 20px;
  overflow: hidden;

  .swiper-button-next {
    background-image: url(${props => props.theme.images.general.rightArrow});
    background-color: #d1d0d04d;
    background-repeat: no-repeat;
    background-position: 55% center;
    width: 32px;
    height: 32px;
    box-shadow: rgb(0 0 0 / 7%) 0px 4px 10px;
    border-radius: 50%;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.05);
    }
  }

  .swiper-button-prev {
    // background-image: url(${props => props.theme.images.general.leftArrow});
    background-color:rgb(255, 255, 255);
    background-position: 45% center;
    width: 20px;
    height: 50px;
    transition: all 0.2s ease;

    &:hover {
      transform: scale(1.05);
    }
  }
    .swiper-button-next {
    background-image: none !important;
    background-color:rgb(255, 255, 255) !important;
    background-position: 45% center;
    width: 20px !important;
    height: 50px !important;
    transition: all 0.2s ease;
    border-radius:0px !important;

    &:hover {
      transform: scale(1.05);
    }
  }
  
  .swiper-button-prev, .swiper-rtl .swiper-button-next {
      left: var(--swiper-navigation-sides-offset, 0px);
      right: auto;
  }
  .swiper-button-next, .swiper-rtl .swiper-button-prev {
      right: var(--swiper-navigation-sides-offset, 0px);
      left: auto;
  }

  .swiper-button-prev, .swiper-button-next{
  color : #000
  }

  .swiper-button-prev:after, .swiper-button-next:after{
  font-size : 15px
  }

  @media (max-width: 992px) {
    height:auto;
  }
`
export const ImageWrapper = styled.div`
  cursor: pointer;
  width: 100%;
  padding-top: 18%;
  position: relative;

  .banner-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
